import React, { useEffect, useRef, useState, createContext } from "react";
import "./App.scss";
import "./styles/UtilClasses.scss";
import "./styles/DesignTokenClasses.scss";
import { ThreeSkyeWrapper } from "@threeskye/global";
import { withRouter } from "react-router";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { unimpersonate, useStorage, hasFeature, hasOneOfFeatures, useRemote, withRemote } from "./Utils/Utils";
import { useWebsockets } from "./Utils/WebsocketReceiverHook";
import BuilderPage from "./layouts/BuilderPage";
import DataController from "./DataController";
import NoAccess from "./NoAccess";
import MenuWrapper from "./layouts/MenuWrapper";
import NoPermissionsPage from "./layouts/NoPermissionsPage";
import CheckAuthorisation from "./CheckAuthorisation";
import Login from "./Login";
import ActiveWorkflowsPage from "./layouts/ActiveWorkflowsPage/ActiveWorkflowsPage";
import DataManagerPage from "./layouts/AdminPage/DataManagement/DataManagerPage";
import SockJsClient from 'react-stomp';
import CraigsLibraryPage from "./layouts/CraigsLibraryPage/CraigsLibraryPage";
import AdminPage from "./layouts/AdminPage/AdminPage";
import DistributionList from "./layouts/CompanyUserManagement/Distribution/DistributionList";
import SettingsProfile from "./layouts/Settings/Profile/SettingsProfilePage";
import SettingsGeneralPage from "./layouts/Settings/General/SettingsGeneralPage";
import UsersLists from "./layouts/CompanyUserManagement/User/UsersLists";
import UserPage from "./layouts/CompanyUserManagement/User/UserPage";
import CompanyLists from "./layouts/CompanyUserManagement/Company/CompanyLists";
import CompanyPage from "./layouts/CompanyUserManagement/Company/CompanyPage";
import ToastContainer from "./components/popups/ToastContainer";
import DistributionListPage from "./layouts/CompanyUserManagement/Distribution/DistributionListPage";
import ErrorPage from "./layouts/ErrorPage";
import DeliveryDetails from "./layouts/CraigsLibraryPage/DeliveryDetails";
import SuppressionList from "./layouts/CompanyUserManagement/Distribution/SuppressionList";
// Analytics
import AnalyticsPage from "./layouts/Analytics/AnalyticsPage";
import AnalyticsGenericList from "./layouts/Analytics/AnalyticsGenericList"
import AnalyticsIndividualPage from "./layouts/Analytics/AnalyticsIndividualPage";
import AnalyticsTickerPage from "./layouts/Analytics/Tickers/AnalyticsTickerPage"
import AnalyticsTickerResearchViews from "./layouts/Analytics/Tickers/AnalyticsTickerResearchViews"
import AnalyticsUsersList from "./layouts/Analytics/Users/AnalyticsUsersList";
import AnalyticsUserPage from "./layouts/Analytics/Users/AnalyticsUserPage";
import AnalyticsUserResearchViews from "./layouts/Analytics/Users/AnalyticsUserResearchView"
import AnalyticsCompaniesList from "./layouts/Analytics/Companies/AnalyticsCompaniesList";
import AnalyticsCompanyPage from "./layouts/Analytics/Companies/AnalyticsCompanyPage";
import DraftsLibrary from "./layouts/Drafts/DraftsLibrary";
import RequestsLibrary from "./layouts/Drafts/RequestsLibrary";
import AnalyticsAuthorPage from "./layouts/Analytics/Authors/AnalyticsAuthorPage";
import AnalyticsPortfoliosList from "./layouts/Analytics/Portfolios/AnalyticsPortfoliosList";
import AnalyticsPracticesList from "./layouts/Analytics/Portfolios/AnalyticsPracticesList";
import AnalyticsManagersList from "./layouts/Analytics/Portfolios/AnalyticsManagersList";
import AnalyticsPortfolioPage from "./layouts/Analytics/Portfolios/AnalyticsPortfolioPage";
import AnalyticsManagerPage from "./layouts/Analytics/Portfolios/AnalyticsManagerPage";
import AnalyticsPracticePage from "./layouts/Analytics/Portfolios/AnalyticsPracticePage";
import AnalyticsVideosList from "./layouts/Analytics/Videos/AnalyticsVideosList";
import AnalyticsVideoPage from "./layouts/Analytics/Videos/AnalyticsVideoPage";
import defaultAnalyticsConfig from "./layouts/Analytics/AnalyticsPortfolioLayout.json"
import HelpPage from "./layouts/Help/HelpPage";
import ComparePage from "./layouts/ComparePage/ComparePage";
import BunnyTestPage from "./layouts/BunnyTest/BunnyTestPage";
import { useHistory, useLocation } from 'react-router-dom';

export const PAGES = {
	EDITOR: "editor",
	COMPARE: "compare",
	LIBRARY: "library",
	DRAFTS: "drafts",
	ADMIN: "admin",
	CRM: "crm",
	ANALYTICS: "analytics",
	DRAFTS: "drafts",
	REQUESTS: "requests",
	ACTIVE_WORKFLOWS: "active-workflows",
	DATA_MANAGEMENT: "data",
	HELP: "help",
	BUNNY_TEST: "bunny-test"
};

export const ROUTE_PATHS = {
	[PAGES.EDITOR]: "/editor",
	[PAGES.COMPARE]: "/compare",
	[PAGES.LIBRARY]: "/",
	[PAGES.DRAFTS]: "/drafts",
	[PAGES.ADMIN]: "/admin",
	[PAGES.CRM]: "/crm",
	[PAGES.SETTINGS]: "/settings",
	[PAGES.ANALYTICS]: "/analytics",
	[PAGES.DRAFTS]: "/drafts",
	[PAGES.REQUESTS]: "/requests",
	[PAGES.ACTIVE_WORKFLOWS]: "/active-workflows",
	[PAGES.DATA_MANAGEMENT]: "/data",
	[PAGES.HELP]: "/help",
	[PAGES.BUNNY_TEST]: "/bunny-test"
};

export const BannerContext = createContext({
	bannerBreadCrumbs: null,
	setBannerBreadCrumbs: () => { },
	bannerAdditionalContent: null,
	setBannerAdditionalContent: () => { },
	bacNoDivider: false,
	setBacNoDivider: () => { },
	bannerAdditionalInfo: null,
	setBannerAdditionalInfo: () => { },

});
export const NotificationsContext = createContext({ activeNotification: null, setActiveNotification: () => { } })

// Wait before each reconnect attempt: rides out about three minutes of outage (a backend deploy or restart)
const SOCKET_RECONNECT_DELAYS_MS = [1000, 2000, 4000, 8000, 16000, 30000, 30000, 30000, 30000, 30000]
// A connection must stay up this long before the attempts count resets, so connect-then-drop still backs off
const SOCKET_STABLE_CONNECTION_MS = 10000

const AuthIntercept = () => {

	const [authenticated, setAuthenticated] = useState(false);
	const [me, setMe] = useState(null);
	const [socketAuth, setSocketAuth] = useState("");
	const [topMessage, setTopMessage] = useState(null);
	const [organisation, setOrganisation] = useState(null);
	const [helpPage, setHelpPage] = useState(false);
	const [helpVideos, setHelpVideos] = useState([]);
	const [loadingRole, setLoadingRole] = useState(true);
	const [bannerBreadCrumbs, setBannerBreadCrumbs] = useState(null)
	const [bannerAdditionalContent, setBannerAdditionalContent] = useState(null)
	const [bannerAdditionalInfo, setBannerAdditionalInfo] = useState(null)
	const [bacNoDivider, setBacNoDivider] = useState(false)
	const [isConnected, setIsConnected] = useState(false);
	const [activeNotification, setActiveNotification] = useState(null)
	const [isExternalManager, setIsExternalManager] = useState(true)
	const [analyticsConfig, setAnalyticsConfig] = useState(null)

	const remote = useRemote();
	const storage = useStorage();
	const clientRef = useRef(null)
	const wsSourceUrl = "https://" + window.location.host + "/websocket?" + socketAuth;
	const sockets = useWebsockets();

	const history = useHistory()
	const location = useLocation();

	const customSocketHeaders = {
		"Authorization": sessionStorage.getItem('3skye.auth.token')
	}

	const handleSocketMessage = ((msg, topic) => {
		sockets.handleMessage(topic, msg);
	})

	// The socket key from crm/socket-auth is accepted for 10 seconds and once a socket closes it is gone, so
	// react-stomp's own retry (same URL, same key) can never reconnect. Each attempt fetches a fresh key instead;
	// the new key remounts SockJsClient (key={socketAuth}), which only reads its URL when it mounts.
	// One object per login: logging out replaces it, so a key request still in flight from the previous session
	// sees it is stale and is dropped instead of connecting with that session's key.
	const authenticatedRef = useRef(authenticated);
	authenticatedRef.current = authenticated;
	const newReconnectState = () => ({ attempts: 0, timer: null, stable: null });
	const reconnectRef = useRef(newReconnectState());

	const requestSocketKey = () => {
		const reconnect = reconnectRef.current;
		const current = () => { reconnect.timer = null; return reconnectRef.current === reconnect && authenticatedRef.current; };
		remote.get("crm/socket-auth")
			.then((auth) => {
				if (!current()) return;
				if (auth?.totp) setSocketAuth(auth.totp);
				else scheduleReconnect();
			})
			// no key (network down): no client is created to fail, so this attempt schedules the next itself
			.catch(() => { if (current()) scheduleReconnect(); });
	};

	const scheduleReconnect = () => {
		const reconnect = reconnectRef.current;
		if (!authenticatedRef.current || reconnect.timer || reconnect.attempts >= SOCKET_RECONNECT_DELAYS_MS.length) return;
		reconnect.timer = setTimeout(requestSocketKey, SOCKET_RECONNECT_DELAYS_MS[reconnect.attempts++]);
	};

	const handleConnect = () => {
		setIsConnected(true);
		const reconnect = reconnectRef.current;
		clearTimeout(reconnect.stable);
		reconnect.stable = setTimeout(() => { reconnect.attempts = 0; }, SOCKET_STABLE_CONNECTION_MS);
	};

	const handleDisconnect = () => {
		setIsConnected(false);
		clearTimeout(reconnectRef.current.stable);
		scheduleReconnect();
	};

	useEffect(() => {
		//console.log("Location is ", location.pathname)
	}, [location])

	useEffect(() => {
		if (!authenticated) {
			clearTimeout(reconnectRef.current.timer);
			clearTimeout(reconnectRef.current.stable);
			reconnectRef.current = newReconnectState();
			setSocketAuth(""); // Reset socket auth if not authenticated
			if (isConnected && clientRef.current) {
				clientRef.current.disconnect(); // Disconnect WebSocket if logged out
			}
			return;
		}

		remote.registerLogoutHandler(handleLogout);
		remote.get("crm/company").then(setOrganisation);
		remote.get("crm/me").then((me) => {
			if (me?.perms.includes("EXTERNAL_EDITOR") && !me?.perms.includes("EDIT")) {
				setIsExternalManager(true)
			} else setIsExternalManager(false)
			setMe(me);
			// the page does not wait on the socket: a failed first key goes into the reconnect attempts
			setLoadingRole(false);
			requestSocketKey();
		});
	}, [authenticated])

	// Visibility change detection and reconnection
	useEffect(() => {
		const handleVisibilityChange = () => {
			if (document.visibilityState === 'visible') {
				// also covers a login whose first key never arrived, when no client exists yet
				if (authenticated && !isConnected) {
					// back on the tab: a fresh round of attempts
					reconnectRef.current.attempts = 0;
					scheduleReconnect();
				}
			} else {
			}
		};

		document.addEventListener('visibilitychange', handleVisibilityChange);
		return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
	}, [authenticated, isConnected, socketAuth]);


	useEffect(() => {
		if (authenticated && me) {
			remote.get('crm/help/videos').then(videos => {
				setHelpVideos(videos || []);
				setHelpPage(videos && videos.length > 0);
			}).catch(() => {
				setHelpVideos([]);
				setHelpPage(false);
			});
		} else {
			setHelpVideos([]);
			setHelpPage(false);
		}
	}, [authenticated, me])

	useEffect(() => {
		if (!organisation) return;

		const applyConfig = (data) => {
			if (data && data.config !== null && data.mainTab) {
				// Stored configs replace the default wholesale, so tabs added after a tenant's
				// config was saved would silently vanish. Append the Videos tab (CFS-96) when
				// absent — trade-off: it can't be removed via stored config while this shim exists.
				if (data.tabs && !data.tabs.some(tab => tab.path === "/videos")) {
					const videosTab = defaultAnalyticsConfig.tabs.find(tab => tab.path === "/videos");
					if (videosTab) data = { ...data, tabs: [...data.tabs, videosTab] };
				}
				setAnalyticsConfig(data);
			} else {
				setAnalyticsConfig(defaultAnalyticsConfig);
			}
		};

		storage.getOrFetch("crm/analytics-config")
			.then(applyConfig)
			.catch(() => setAnalyticsConfig(defaultAnalyticsConfig));

		storage.watch("crm/analytics-config", applyConfig);
		return () => storage.unwatch("crm/analytics-config", applyConfig);
	}, [organisation])

	const handleLogout = () => {
		setAuthenticated(false);
	}

	const sendMessage = (msg) => {
		clientRef.current.sendMessage('/app/test', msg);
	}

	function getAnalyticComponent(string) {
		switch (string) {
			case "AnalyticsCompaniesList":
				return <AnalyticsCompaniesList />
			case "AnalyticsPortfoliosList":
				return <AnalyticsPortfoliosList />
			case "AnalyticsManagersList":
				return <AnalyticsManagersList />
			case "AnalyticsPracticesList":
				return <AnalyticsPracticesList />
			case "AnalyticsUsersList":
				return <AnalyticsUsersList />
			case "AnalyticsVideosList":
				return <AnalyticsVideosList />
			default:
				break;
		}
	}

	if (!authenticated || loadingRole) {
		return <CheckAuthorisation setAuthorised={setAuthenticated} />
	}
	const userHasNoPermissions = me === null || (me && me.perms && me.perms.length < 1)
	const jsonFile = analyticsConfig || defaultAnalyticsConfig
	const tabName = jsonFile.mainTab.name
	const tabPath = jsonFile.mainTab.path

	// console.log("me", me)
	// console.log("externalEditor", me.perms.includes("EXTERNAL_EDITOR"))
	// console.log("edit", me.perms.includes("EDIT"))
	// console.log("pathname ", location.pathname, location.pathname === '/')

	if (me && me.perms.includes("EXTERNAL_EDITOR") && !me.perms.includes("EDIT") && location.pathname === '/') {
		// console.log("Pushing editor")
		history.push("/editor")
		return null;
	}

	return (
		<BannerContext.Provider value={{
			bannerBreadCrumbs: bannerBreadCrumbs,
			setBannerBreadCrumbs: setBannerBreadCrumbs,
			bannerAdditionalContent,
			setBannerAdditionalContent: setBannerAdditionalContent,
			bacNoDivider: bacNoDivider,
			setBacNoDivider: setBacNoDivider,
			bannerAdditionalInfo: bannerAdditionalInfo,
			setBannerAdditionalInfo: setBannerAdditionalInfo
		}}>
			<NotificationsContext.Provider value={{ activeNotification: activeNotification, setActiveNotification: setActiveNotification }}>
				<MenuWrapper topComponent={topMessage} user={me} updateUser={setMe} noPermissions={userHasNoPermissions} organisation={organisation} sendMessage={sendMessage} isExternalManager={isExternalManager} helpPage={helpPage} helpVideos={helpVideos} analyticsConfig={analyticsConfig}>
					{socketAuth && <SockJsClient
						key={socketAuth}
						headers={{ credentials: "same-origin" }}
						url={wsSourceUrl}
						topics={['/topic/broadcast', '/user/topic/message', '/user/topic/updates', '/topic/updates']}
						onMessage={handleSocketMessage}
						ref={(client) => { clientRef.current = client }}
						onConnect={() => { handleConnect() }}
						onDisconnect={() => { handleDisconnect() }}
						autoReconnect={false}
						onConnectFailure={() => { scheduleReconnect() }}
						debug={false}
					/>}
					<Switch>
						{userHasNoPermissions && < Route path="*" component={NoPermissionsPage} noPermissions={userHasNoPermissions} />}
						<Route
							exact
							path={ROUTE_PATHS[PAGES.EDITOR]}
							render={() => (
								<ProtectedRoute user={me} requiredFeature={["EDIT", "EXTERNAL_EDITOR"]}>
									<DataController internalApi={true} setTopMessage={setTopMessage} isExternalManager={isExternalManager}>
										<BuilderPage organisation={organisation} setTopMessage={setTopMessage} isExternalManager={isExternalManager} />
									</DataController>
								</ProtectedRoute>
							)}
						/>

						{/* Compare Documents (RES-561) — EDIT-only: external managers
						(EXTERNAL_EDITOR without EDIT) are bounced even by direct URL
						(follow-up item 1). */}
						<Route
							exact
							path={ROUTE_PATHS[PAGES.COMPARE] + "/:ticker/:template"}
							render={() => (
								<ProtectedRoute user={me} requiredFeature={"EDIT"}>
									<ComparePage />
								</ProtectedRoute>
							)}
						/>

						{/* Settings and Profile Pages */}
						<Route path={ROUTE_PATHS[PAGES.SETTINGS] + "/profile"} component={SettingsProfile} />
						<Route path={ROUTE_PATHS[PAGES.SETTINGS] + "/general"} component={SettingsGeneralPage} />

						{/* Bunny Test Page — dev only */}
						{process.env.NODE_ENV === 'development' && <Route exact path={ROUTE_PATHS[PAGES.BUNNY_TEST]} component={BunnyTestPage} />}

						{/* Drafts Workspace/Requests Routes */}
						<Route exact path={ROUTE_PATHS[PAGES.DRAFTS]} component={hasOneOfFeatures(["DRAFTS_ANALYST", "DRAFTS_PEER"], DraftsLibrary, me)} />
						<Route exact path={ROUTE_PATHS[PAGES.REQUESTS]} component={hasOneOfFeatures(["REVIEW_PEER", "REVIEW_COMPLIANCE", "REVIEW_SUPERVISOR", "REVIEW_SPOT"], RequestsLibrary, me)} />
						<Route exact path={ROUTE_PATHS[PAGES.REQUESTS] + "/:requestId"} component={hasOneOfFeatures(["REVIEW_PEER", "REVIEW_COMPLIANCE", "REVIEW_SUPERVISOR", "REVIEW_SPOT"], RequestsLibrary, me)} />

						{/* ANALYCTICS Routes */}
						{/*For now portfolios, users and companies have their own component. Tickers, groups and authors use the generic component*/}
						{jsonFile?.tabs?.map((tab, index) => {
							if (index === 0) {
								return (
									<Route
										key={"analytics-tabs-" + index}
										path={ROUTE_PATHS[PAGES.ANALYTICS] + tabPath}
										render={(props) =>
											<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
												<AnalyticsPage tabName={tabName} content={jsonFile.mainTab} />
											</ProtectedRoute>
										} />
								)
							} else if (tab.specialComponent) {
								return <Route
									key={"analytics-tabs-" + index}
									exact
									path={ROUTE_PATHS[PAGES.ANALYTICS] + tab.path}
									render={(props) =>
										<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
											{getAnalyticComponent(tab.specialComponent)}
										</ProtectedRoute>
									} />
							} else {
								return <Route
									key={"analytics-tabs-" + index}
									exact
									path={ROUTE_PATHS[PAGES.ANALYTICS] + tab.path}
									render={(props) =>
										<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
											<AnalyticsGenericList
												listData={jsonFile.tabs[index].listData}
												individualPagePath={jsonFile.tabs[index].individualPage}
												name={jsonFile.tabs[index].name}
												path={jsonFile.tabs[index].path}
											/>
										</ProtectedRoute>
									} />
							}
						})}
						{jsonFile?.subtabs?.map((subTab, index) => {
							if (subTab.specialComponent) {
								return <Route
									key={"analytics-subtabs-" + index}
									exact
									path={ROUTE_PATHS[PAGES.ANALYTICS] + subTab.path}
									render={(props) =>
										<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
											{getAnalyticComponent(subTab.specialComponent)}
										</ProtectedRoute>
									} />
							} else {
								return <Route
									key={"analytics-subtabs-" + index}
									exact
									path={ROUTE_PATHS[PAGES.ANALYTICS] + subTab.path}
									render={(props) =>
										<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
											<AnalyticsIndividualPage
												listData={jsonFile.subtabs[index].listData}
												individualPagePath={jsonFile.subtabs[index].individualPage}
												name={jsonFile.subtabs[index].name}
												path={jsonFile.subtabs[index].path}
											/>
										</ProtectedRoute>
									} />
							}
						})}
						<Route
							exact
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/authors/author/:authorId"}
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsAuthorPage datatita={props} />
								</ProtectedRoute>
							} />
						<Route
							exact
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/tickers/:tickerId"}
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsTickerPage datatita={props} />
								</ProtectedRoute>
							} />
						<Route
							exact
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/portfolios/:tickerId"} // replace with :portfolioId
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsPortfolioPage datatita={props} jsonFile={jsonFile} />
								</ProtectedRoute>
							} />
						<Route
							exact
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/managers/:managerId"} // replace with :portfolioId
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsManagerPage datatita={props} jsonFile={jsonFile} />
								</ProtectedRoute>
							} />
						<Route
							exact
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/practices/:practiceId"} // replace with :portfolioId
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsPracticePage datatita={props} jsonFile={jsonFile} />
								</ProtectedRoute>
							} />
						<Route
							exact
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/videos/:videoId"}
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsVideoPage datatita={props} />
								</ProtectedRoute>
							} />
						<Route
							exact
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/group/:groupId"}
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsTickerPage datatita={props} />
								</ProtectedRoute>
							}
						/>
						<Route
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/tickers/:tickerId/research/:researchId"}
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsTickerResearchViews datatita={props} />
								</ProtectedRoute>
							} />
						<Route
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/group/:groupId/research/:researchId"}
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsTickerResearchViews datatita={props} />
								</ProtectedRoute>
							} />
						<Route
							path={ROUTE_PATHS[PAGES.ANALYTICS] + "/users/user/:userId/research/:researchId"}
							render={(props) =>
								<ProtectedRoute user={me} requiredFeature={"ANALYTICS_VIEW"}>
									<AnalyticsUserResearchViews datatita={props} />
								</ProtectedRoute>
							} />

						<Route exact path={ROUTE_PATHS[PAGES.ANALYTICS] + "/users"} component={hasFeature("ANALYTICS_VIEW", AnalyticsUsersList, me)} />
						<Route path={ROUTE_PATHS[PAGES.ANALYTICS] + "/users/user/:userId"} component={hasFeature("ANALYTICS_VIEW", AnalyticsUserPage, me)} />
						<Route exact path={ROUTE_PATHS[PAGES.ANALYTICS] + "/companies"} component={hasFeature("ANALYTICS_VIEW", AnalyticsCompaniesList, me)} />
						<Route path={ROUTE_PATHS[PAGES.ANALYTICS] + "/companies/company/:companyId"} component={hasFeature("ANALYTICS_VIEW", AnalyticsCompanyPage, me)} />

						{/* Admin Routes - subpages contained inside <AdminPage /> */}
						<Route
							path={ROUTE_PATHS[PAGES.ADMIN]}
							render={() =>
								<ProtectedRoute user={me} requiredFeature={["TICKERS", "MODEL_PORTFOLIOS", "ASSET_CLASS_MGT", "SECTORS", "DISCLAIMER", "USER_MANAGEMENT", "COMPANY_MANAGEMENT", "PORTFOLIO_MANAGEMENT", "ROLES", "TEMPLATES"]} >
									<AdminPage me={me} organisation={organisation} />
								</ProtectedRoute>
							} />

						{/* CRM Routes */}
						<Route exact path={ROUTE_PATHS[PAGES.CRM] + "/users"} component={hasFeature("USERS", UsersLists, me)} />
						<Route path={ROUTE_PATHS[PAGES.CRM] + "/users/user/:userId"} component={hasFeature("USERS", UserPage, me)} />
						<Route exact path={ROUTE_PATHS[PAGES.CRM] + "/companies"} component={hasFeature("COMPANIES", CompanyLists, me)} />
						<Route path={ROUTE_PATHS[PAGES.CRM] + "/companies/company/:companyId"} component={hasFeature("COMPANIES", CompanyPage, me)} />
						<Route exact path={ROUTE_PATHS[PAGES.CRM] + "/distribution"} component={hasFeature("DISTRIBUTION", DistributionList, me)} />
						<Route exact path={ROUTE_PATHS[PAGES.CRM] + "/distribution/distribution-list/:distributionListId"} component={hasFeature("DISTRIBUTION", DistributionListPage, me)} />
						<Route exact path={ROUTE_PATHS[PAGES.CRM] + "/suppressions"} component={hasFeature("SUPPRESSED_EMAILS", SuppressionList, me)} />

						{/* Process Dashboard */}
						<Route path={ROUTE_PATHS[PAGES.ACTIVE_WORKFLOWS]} component={ActiveWorkflowsPage} />

						{/* Help Page */}
						{me && helpPage && <Route path={ROUTE_PATHS[PAGES.HELP] + "/:guideId"} component={HelpPage} />}
						{me && helpPage && <Route path={ROUTE_PATHS[PAGES.HELP]} component={HelpPage} />}

						{/* Data Manager */}
						<Route exact path={ROUTE_PATHS[PAGES.DATA_MANAGEMENT]} component={hasFeature("DATA_MANAGEMENT", DataManagerPage, me)} />

						{/* Library Pages */}
						<Route path={ROUTE_PATHS[PAGES.CRM] + "/delivery/:deliveryId"} component={DeliveryDetails} />
						<Route exact component={hasFeature("LIBRARY_VIEW", CraigsLibraryPage, me)} />

						{/* 404/error page */}
						<Route path="*" component={ErrorPage} />
					</Switch>
				</MenuWrapper>
			</NotificationsContext.Provider>
		</BannerContext.Provider>
	);
}

const ProtectedRoute = ({ user, requiredFeature, children }) => {

	if (Array.isArray(requiredFeature)) {
		if (user && user.perms && requiredFeature.some(f => { return user.perms.includes(f) })) {
			return children;
		}
	} else if (user && user.perms && user.perms.includes(requiredFeature)) {
		return children;
	}

	return <ErrorPage />
};

const ImpersonationWrapper = ({ remote, ...others }) => {
	const storage = useStorage();

	const logout = (storage) => {
		unimpersonate(storage);
	}

	return <AuthIntercept logout={() => logout(storage)} remote={remote} {...others} />
}

const InternalApiApp = () => {
	const remote = useRemote();

	const component = window.sessionStorage.getItem("3skye.auth.super.token") !== null ? ImpersonationWrapper : AuthIntercept;
	const hocd = withRemote(withRouter(component));

	return (
		<ThreeSkyeWrapper disableI18n={true}>
			<ToastContainer />
			<BrowserRouter>
				<Switch>
					{/* <Route exact path="/authorise/:token" component={Authorise} />
						<Route exact path="/authorise" component={CheckAuthorisation} />
						<Route path="/ext/:comp" component={Extensions} /> */}
					<Route path="/no-access" component={NoAccess} />
					<Route exact path="/sign-in" component={Login} />
					<Route path="/sign-in/:serviceName" component={Login} />
					<Route component={hocd} />
				</Switch>
			</BrowserRouter>
		</ThreeSkyeWrapper>
	);
}

export default (InternalApiApp);
